import { isLightTheme } from 'lib/themes/theme';
import darkColors from '../../lib/themes/dark-colors.module.scss';

const { reportLightGrey, reportDarkGrey, reportLightBlue, reportTextGrey } = darkColors;

export const styles = theme => ({
  reportContainer: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  reportTitle: {
    color: theme.palette.primary.pageHeader,
    fontSize: theme.font.extraLargeFontSize,
    fontWeight: theme.font.weight.thick,
  },
  card: {
    width: '90%',
    margin: 10,
    cursor: 'pointer',
  },
  cardHeader: {
    paddingBottom: 0,
    color: isLightTheme() ? theme.palette.primary.main : reportLightBlue,
  },
  subCardHeader: {
    paddingBottom: 0,
    fontSize: theme.font.largeFontSize,
    color: isLightTheme() ? theme.palette.primary.main : reportLightBlue,
  },
  metricContainer: {
    marginLeft: 20,
    cursor: 'pointer',
    padding: 15,
  },
  number: {
    display: 'inline',
    color: isLightTheme() ? theme.palette.primary.main : reportLightBlue,
  },
  percentage: {
    marginLeft: 10,
    fontSize: theme.font.extraSmallFontSize,
    color: isLightTheme() ? theme.palette.primary.main : reportLightBlue,
  },
  containerTabWrapper: {
    position: 'relative',
    backgroundColor: isLightTheme() ? theme.palette.primary.background : reportLightGrey,
    padding: theme.spacing(2),
  },
  noReportSelectedContainerWrapper: {
    // opacity: 0.5,
  },
  noReportSelectedTxt: {
    'width': '100%',
    'textAlign': 'center',
    'zIndex': 999,
    'marginTop': '15%',
    'position': 'absolute',
    '& .MuiButton-root': {
      float: 'inherit',
      marginTop: 6,
    },
    '& p': {
      fontSize: 36,
      fontWeight: 'bold',
    },
  },
  downloadButton: {
    textDecoration: 'none',
    color: theme.palette.primary.white,
  },
  reportTable: {
    cursor: 'pointer',
  },
  loadContainer: {
    position: 'relative',
    minHeight: 150,
  },
  reportSection: {
    marginTop: 20,
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    borderRadius: 5,
    padding: 20,
    backgroundColor: isLightTheme() ? theme.palette.primary.background : reportDarkGrey,
    color: isLightTheme() ? theme.palette.primary.main : reportLightBlue,
  },
  reportSectionTitle: {
    marginTop: 10,
    marginBottom: 10,
    color: isLightTheme() ? '#000000' : theme.palette.text.primary,
    fontSize: theme.font.largeFontSize,
    fontWeight: theme.font.weight.thick,
  },
  filterLabel: {
    fontSize: '0.75rem',
    color: isLightTheme() ? 'inherit' : theme.palette.text.primary,
  },
  filterChip: {
    backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : undefined,
    margin: '2px',
  },
  filtersRow: {
    marginBottom: theme.spacing(2),
  },
  chartCard: {
    width: '100%',
    backgroundColor: isLightTheme()
      ? theme.palette.primary.background
      : theme.palette.primary.darkGrey,
    borderColor: isLightTheme() ? theme.palette.primary.main : 'black',
    color: isLightTheme() ? theme.palette.primary.main : reportTextGrey,
    backgroundImage: 'none',
  },
  tabRoot: {
    '&.Mui-tabSelected': {
      color: theme.palette.navigation.secondary,
    },
    '&:focus': {
      color: theme.palette.primary.hover,
    },
  },
  secondaryTabRoot: {
    '&.Mui-tabSelected': {
      color: theme.palette.primary.hover,
    },
    '&:focus': {
      color: theme.palette.primary.hover,
    },
  },
  secondaryTabsIndicator: {
    backgroundColor: theme.palette.primary.hover,
  },
  tabSelected: {},
  tabsHr: {
    marginTop: 0,
    // eslint-disable-next-line comma-dangle
    // opacity: 0.3,
    // eslint-disable-next-line comma-dangle
  },
  generalReportTable: {
    marginBottom: '1rem',
    fontFamily: "'Gotham SSm A', 'Gotham SSm B', Verdana, Geneva, Tahoma, sans-serif",
    padding: theme.spacing(0),
  },
  generalReportTableContainer: {
    'overflow': 'scroll',
    'maxHeight': '60vh',
    '& thead th': {
      position: 'sticky',
      top: 0,
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : reportDarkGrey,
      zIndex: 1,
      padding: 0,
      borderBottom: '1px solid #f0f0f0',
      borderRight: '1px solid #f0f0f0',
    },
  },
  generalReportTableMain: {
    'minWidth': '100%',
    'borderSpacing': 0,
    'borderCollapse': 'collapse',
    'border': '1px solid #f0f0f0',
    '& tr': {
      'fontSize': '0.8125rem',
      '& td': {
        borderTop: '1px solid #f0f0f0',
      },
    },
  },
  generalReportHeaderTr: {
    'minWidth': '100%',
    'height': '100%',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    '& th > input': {
      padding: theme.spacing(0),
      textIndent: theme.spacing(1),
    },
  },
  generalReportHeaderTh: {
    'fontWeight': 'bold',
    'fontSize': theme.spacing(1.75),
    'minWidth': 150,
    'height': theme.spacing(4.5),
    'textAlign': 'center',
    '&:first-of-type': {
      textAlign: 'center',
    },
  },
  generalReportMainTbody: {
    '& tr:nth-child(even)': {
      'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226',
      '& td': {
        backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226 !important',
      },
    },
    '& tr:nth-child(odd)': {
      'backgroundColor': isLightTheme() ? theme.palette.primary.background : reportLightGrey,
      '& td': {
        backgroundColor: isLightTheme()
          ? theme.palette.primary.background
          : `${reportLightGrey} !important`,
      },
    },
    '& tr': {
      height: theme.spacing(4.5),
    },
    '& td': {
      'position': 'relative',
      'borderRight': '1px solid #f0f0f0',
      '& :last-child': {
        borderRight: 0,
      },
      '& td.resizer': {
        display: 'inline-block',
        background: theme.palette.primary.steelGrey,
        width: '10px',
        height: '100%',
        top: 0,
        transform: 'translateX(10%)',
        zIndex: 1,
        touchAction: 'none',
      },
    },
  },
  generalReportTbodyTr: {
    'textAlign': 'center',
    'textOverflow': 'ellipsis',
    'overflow': 'hidden',
    'whiteSpace': 'nowrap',
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.primary.background,
    },
  },
  firstColumnCell: {
    fontWeight: 'bold',
  },
  oddRow: {
    'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226',
    '& td': {
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226 !important',
    },
  },
  totalRow: {
    '& td': {
      fontWeight: theme.font.weight.thick,
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#282d33 !important',
    },
    'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : '#282d33',
    '& $stickyRightCell': {
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#282d33 !important',
    },
  },
  stickyRightHeader: {
    position: 'sticky !important',
    top: '0 !important',
    right: '0 !important',
    zIndex: '2 !important',
    backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : reportDarkGrey,
    boxShadow: '-1px 0 0 0 #f0f0f0',
  },
  stickyRightCell: {
    position: 'sticky !important',
    right: 0,
    zIndex: 1,
    backgroundColor: isLightTheme() ? theme.palette.primary.background : reportDarkGrey,
    boxShadow: '-1px 0 0 0 #f0f0f0',
  },
  stickyRightCellOdd: {
    backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226 !important',
  },
  stickyRightCellEven: {
    backgroundColor: isLightTheme()
      ? theme.palette.primary.background
      : `${reportLightGrey} !important`,
  },
  paginationBtnsContainer: {
    backgroundColor: isLightTheme()
      ? theme.palette.primary.white
      : theme.palette.primary.background,
    border: '1px solid #f0f0f0',
    minHeight: theme.spacing(6),
  },
  paginationBtns: {
    'padding': theme.spacing(0.5),
    '& button': {
      width: '100%',
      height: '100%',
      border: 0,
      borderRadius: theme.spacing(0.5),
      fontSize: 14,
      transition: 'all .1s ease',
      cursor: 'pointer',
      outlineWidth: 0,
      backgroundColor: isLightTheme() ? theme.palette.primary.background : reportLightGrey,
      color: isLightTheme() ? theme.palette.primary.main : reportTextGrey,
    },
  },
  paginationControls: {
    'textAlign': 'center',
    '& span': {
      'height': theme.spacing(6),
      'lineHeight': theme.spacing(6),
      'display': 'inline-block',
      '& select': {
        height: theme.spacing(4.5),
        border: '1px solid #f0f0f0',
        backgroundColor: isLightTheme() ? theme.palette.primary.background : reportLightGrey,
        color: isLightTheme() ? theme.palette.primary.main : reportTextGrey,
      },
      '& input': {
        height: theme.spacing(4),
        minWidth: theme.spacing(2.5),
        border: '1px solid #f0f0f0',
        backgroundColor: isLightTheme() ? theme.palette.primary.background : reportLightGrey,
        color: isLightTheme() ? theme.palette.primary.main : reportTextGrey,
        textIndent: theme.spacing(1),
      },
    },
  },
});
